// File Metadata:
// Filename: NewArrival.js
// Version: 1.00
// Created: 2025-03-22 00:05:56
// Last Modified: 2025-04-01 17:27:27
// Authors: [Your Name]
// Description: A brief summary of what this file does

import React, { Component } from 'react'
import NewArrivalFormHU from './NewArrivalFormHU'
import NewArrivalFormPicture from './NewArrivalFormPicture'
import NewArrivalFormConfirm from './NewArrivalFormConfirm'

export class NewArrival extends Component {
    state = {
        step: 1,
        handlingUnits: [],
        arrivalTour: '',
        img: [],
        location: '',
        notes: ['']
    }

    nextStep = () => {
        const { step } = this.state
        this.setState({ step: step + 1 })
    }

    prevStep = () => {
        const { step } = this.state
        this.setState({ step: step - 1 })
    }

    handleChange = input => e => {
        this.setState({ [input]: e.target.value })
    }

    handleValue = (input, value) => {
        this.setState({ [input]: value })
    }

    render() {
        const { step } = this.state
        const { handlingUnits, arrivalTour, img, location, notes } = this.state
        const values = { handlingUnits, arrivalTour, img, location, notes }

        switch (step) {
            case 1:
                return <NewArrivalFormHU
                    nextStep={this.nextStep}
                    handleChange={this.handleChange}
                    handleValue={this.handleValue}
                    values={values}
                />
            case 2:
                return <NewArrivalFormPicture
                    nextStep={this.nextStep}
                    prevStep={this.prevStep}
                    handleValue={this.handleValue}
                    values={values}
                />
            case 3:
                return <NewArrivalFormConfirm
                    prevStep={this.prevStep}
                    values={values}
                />
            default:
                return null
        }
    }
}

export default NewArrival
